import React from "react";
import { Card, message, Button, Tag } from "antd";
import { withRouter } from "react-router-dom";
import { view } from "react-easy-state";

import globalStore from "store/index";
import Lightbox from "components/common/Lightbox/Index";
import MiniPlayer from "components/common/MiniPlayer/Index";
import CommentBox from "components/common/CommetBox/Index";

import DoubtsService from "services/teachers/doubts.service";

class DoubtDetails extends React.Component {
  componentDidMount() {}

  renderAttachments = (attachedFiles) => {
    console.log("attached file", attachedFiles);

    const images = attachedFiles.filter((f) => f.contentType.includes("image"));

    const audios = attachedFiles.filter((f) => f.contentType.includes("audio"));

    return (
      <div style={{ display: "flex" }}>
        <Lightbox images={images} />
        <MiniPlayer audios={audios} />
      </div>
    );
  };

  handlePickDoubtButton = async (doubtId) => {
    const pageState = globalStore.ui.teachers.doubts.pick;
    await DoubtsService.pick({ pageState, doubtId });

    const { doubtErrors, API_DOUBTS_PICK_STATUS } = pageState;

    message.destroy();

    if (API_DOUBTS_PICK_STATUS === "rejected") {
      message.error("Oops!! something went wrong");
    }

    if (doubtErrors) {
      message.error(doubtErrors);
      return;
    }

    globalStore.ui.teachers.doubts.show.doubt = pageState.doubt;

    message.success("You picked this doubt successfully.");
  };

  updateStore = (data) => {
    const showPageStoreData = globalStore.ui.teachers.doubts.show;

    if (showPageStoreData.doubt) {
      showPageStoreData.doubt.doubt_messages = data;
    }
  };

  render() {
    const { doubt, user } = globalStore.ui.teachers.doubts.show;

    if (!doubt) {
      return null;
    }

    return (
      <div>
        <Card
          title={`Doubt - ${doubt.subject && doubt.subject.name} > ${
            doubt.chapter && doubt.chapter.name
          }`}
          extra={
            doubt.picker_id ? (
              <Tag>Doubt picked</Tag>
            ) : (
              <Button
                type="link"
                onClick={() => this.handlePickDoubtButton(doubt.id)}
              >
                Pick Doubt
              </Button>
            )
          }
          style={{ marginBottom: 30 }}
        >
          <p>{doubt.description}</p>
        </Card>
        <Card title="Attachments" style={{ marginBottom: 30 }}>
          {this.renderAttachments(doubt.attached_files)}
        </Card>
        {doubt.picker_id && (
          <Card
            title={`Comments (${doubt.doubt_messages.length})`}
            style={{ marginBottom: 30 }}
          >
            <CommentBox
              doubt={doubt}
              updateStore={this.updateStore}
              currentUser={user}
            />
          </Card>
        )}
      </div>
    );
  }
}

export default withRouter(view(DoubtDetails));
